import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {Col, Row, Spinner} from "react-bootstrap";
import moment from "moment/moment";
import BetterCheckBox from "../../../common/BetterCheckBox";
import Alert from "react-bootstrap/Alert";
import Input from "../../../common/Input";
import Button from "react-bootstrap/Button";
import {useSelector} from "react-redux";
import {isEmpty, validateEmail} from "../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import axios from "axios";

const MassFetchDclModal = ({show, setShow}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [requestData, setRequestData] = useState({sendEmail: false, emails: ""});
    const [loading, setLoading] = useState(false);
    const [consoleMSG, setConsoleMSG] = useState([]);

    useEffect(() => {
        if(show) {
            setConsoleMSG([]);
            setRequestData({sendEmail: false, emails: ""});
        }
    }, [show]);

    const handleOnChange = (e, type, name) => {
        if (type === "db") {
            if (moment(e).isValid()) {
                setRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")})
            } else {
                setRequestData({...requestData, [name] : ""})
            }
        } else if (type === "cb") {
            setRequestData({...requestData, [name] : e.target.checked});
        } else if (type === "input") {
            setRequestData({...requestData, [name] : e.target.value});
        }
    }

    const handleHide = () => {
        if (!loading) {
            setShow(false);
        } else {
            toast.info("Παρακαλώ περιμένετε να τελειώσει η διαδικασία της άντλησης.");
        }
    }


    const handleMassFetch = () => {
        if (requestData.sendEmail) {
            if (isEmpty(requestData.emails)) {
                return toast.info("Παρακαλώ συμπληρώστε κάποιο e-mail.");
            } else if (String(requestData.emails).split(",").filter(Boolean).some((email) => !validateEmail(email))) {
                return toast.info("Παρακαλώ βεβαιωθείτε ότι όλα τα e-mail είναι σωστά.");
            }
        }
        setLoading(true);
        if(requestData.sendEmail) {
            setShow(false);
            toast.info("Η διαδικασία άντλησης έχει ξεκινήσει! Παρακαλώ περιμένετε...");
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/dcl/mass-fetch`, {
            ...requestData,
            company: company.id,
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success(res.data.message);
                setConsoleMSG(consoleMSG => [...consoleMSG].concat(res.data.logs));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => handleHide()} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Άντληση δεδομένων Ψηφιακού Πελατολογίου από MyData</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{pointerEvents: loading ? "none" : "", opacity: loading ? "0.6" : ""}}>
                        <Alert variant={"secondary"}>
                            <Row>
                                <Col md={12}>
                                    Η διαδικασία μπορεί να διαρκέσει αρκετό χρόνο. Αν δεν επιθυμείτε να περιμένετε, υπάρχει η δυνατότητα αποστολής e-mail όταν τελειώσει.
                                </Col>
                                <Col md={12}>
                                    <BetterCheckBox
                                        name={"sendEmail"}
                                        className={"mt-2"}
                                        text={"Αποστολή e-mail"}
                                        checked={requestData.sendEmail}
                                        onChange={(e) => handleOnChange(e, "cb", "sendEmail")}
                                    />
                                </Col>
                                {requestData.sendEmail && (
                                    <Col md={12}>
                                        <Input
                                            name={"emails"}
                                            label={"e-mails διαχωρισμένα με κόμμα (,)"}
                                            placeholder={"Εισαγάγετε e-mails διαχωρισμένα με κόμμα (,)"}
                                            onChange={(e) => handleOnChange(e, "input", "emails")}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </Alert>
                    </div>
                    {loading && (
                        <div style={{textAlign: "center"}}>
                            Γίνεται άντληση παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                        </div>
                    )}
                    {consoleMSG.length > 0 && (
                        <React.Fragment>
                            <hr />
                            <div className="row">
                                <div className="mb-2 col-12">
                                    <p>Αρχείο καταγραφής σφαλμάτων άντλησης:</p>
                                    <div className="bg-light w-100 border p-3">
                                        {consoleMSG.map(e => <p>{e}</p>)}
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </React.Fragment>
                    )}
                </Modal.Body>
                {!loading && (
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={() => setShow(false)}>
                            Κλείσιμο
                        </Button>
                        <Button variant="primary" onClick={() => handleMassFetch()}>
                            Μαζική άντληση
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </React.Fragment>
    )
}

export default MassFetchDclModal;
